import { FunctionComponent } from "react";
import { NavLink } from "react-router-dom";
import { urls } from "../../../../../utils/urls";
import Card from "../../components/Card";
import { X } from "react-feather";
import { ChevronLeft } from "react-feather";

interface StarterPackProps {}

const StarterPack: FunctionComponent<StarterPackProps> = () => {
  const links = [
    {
      name: "Brochure",
      link: urls.brochure_starter,
      logo: "/academy/insides.png",
    },
    {
      name: "Digital Background",
      link: urls.digital_background_starter,
      logo: "/academy/insides.png",
    },
    {
      name: "Emailer and Deck",
      link: urls.emailer_deck_starter,
      logo: "/academy/insides.png",
    },
    {
      name: "Kazam ID card",
      link: urls.id_card_starter,
      logo: "/academy/insides.png",
    },
    {
      name: "Kazam Stickers",
      link: urls.sticker_starter,
      logo: "/academy/insides.png",
    },
  ];

  return (
    <div className="relative bg-hrmBgLight h-screen">
<div className="absolute top-4 right-0 left-0 flex flex-row justify-between px-4">
  <NavLink to={urls.hrm_profile}>
    <ChevronLeft size={48} />
  </NavLink>

  <NavLink to={urls.kazam_academy}>
    <X className="text-black" size={48} />
  </NavLink>
</div>
      <div className="flex flex-col items-center justify-center pt-20 lg:pt-32">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-12 mt-8 w-11/12 lg:w-4/5">
          {links.map(
            (el: { name: string; link: string; logo?: string }, i: number) => {
              return <Card data={el} />;
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default StarterPack;
